import { defineComponent as _defineComponent } from 'vue'
import PictureComp from '@/components/picture/PictureComp.vue';
import { ArticleMainObjectTitleFragment } from '@/pages/graphql/queries/GetAuthorByUrl.query';


export default /*#__PURE__*/_defineComponent({
  __name: 'PosterStack',
  props: {
    title: null
  },
  setup(__props: any) {



return { __sfc: true,PictureComp }
}

})